import gql from 'graphql-tag'

export const DELETE = gql`
  mutation product_book_delete($id: ID!) {
    productDelete(id: $id)
  }
`
